import * as Actions from './Actions';
import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { connect } from 'react-redux';
import PlanFirmModal from './PlanFirmModal';
import notify from '../../shared/feedback/notifications';
import PlanFirmList from './PlanFirmList';
import { Button } from 'react-bootstrap';
import { handleError } from '../../shared/ErrorCatching';

class PlanFirmsPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            shouldShowModal: false,
            editId: -1
        };

        this.openCreateModal = this.openCreateModal.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.list();
    }

    openCreateModal() {
        this.setState({ editId: -1 });
        this.toggleModal();
    }

    openEditModal(id: number) {
        this.setState({ editId: id });
        this.toggleModal();
    }

    toggleModal() {
        this.setState({ shouldShowModal: !this.state.shouldShowModal });
    }

    delete(id: number): void {
        this.props.actions
            .delete(id)
            .then(() => {
                notify.success(Translate('plan-firm-deleted'));
            })
            .catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('plan-firms/page/title/plan-firms')}</h1>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.openCreateModal}
                    bsStyle="success"
                >
                    {Translate('plan-firms/page/button-label/add-plan-firm')}
                </Button>
                {this.state.shouldShowModal && (
                    <PlanFirmModal
                        editId={this.state.editId}
                        shouldShowModal={this.state.shouldShowModal}
                        closeModal={this.toggleModal}
                    />
                )}
                <PlanFirmList
                    items={this.props.planFirms}
                    beginEdit={this.openEditModal}
                    delete={this.delete}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        planFirms: state.planFirms.list
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            list: () => dispatch(Actions.list()),
            delete: (id: number) => dispatch(Actions.deletePlanFirm(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanFirmsPage);
